
import { mapState, mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import Estoque from "vue-material-design-icons/Toolbox";
import Pessoas from "vue-material-design-icons/AccountGroup";
import Expand from "vue-material-design-icons/ChevronDown";
import Minimize from "vue-material-design-icons/ChevronUp";
import Financeiro from "vue-material-design-icons/Finance";
import ArrowRight from "vue-material-design-icons/ArrowRight";
import Warning from "vue-material-design-icons/AlertCircleOutline";
import "vue-loading-overlay/dist/vue-loading.css";
import { userAccessStore } from "@/userAccessStore";
import { priceOptions, quantityOptions } from "@/modules/Application";
import TableApp from "../../../components/Table/Table3.vue";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import SendToWppModal from "@/components/SendToWppModal";
import NovoDashboardInfo from "../components/NovoDashboardInfo.vue";

export default {
  name: "app-dashboard",
  mixins: [SistemaMixin],
  components: {
    Estoque,
    Pessoas,
    Financeiro,
    Minimize,
    Expand,
    Warning,
    ArrowRight,
    TableApp,
    Whatsapp,
    SendToWppModal,
    NovoDashboardInfo,
  },
  data() {
    return {
      userAccessStore,
      totais: [],
      isSpanded: false,
      priceOptions,
      quantityOptions,
      resumo: {},
      isLoading: false,
      isLoadingResumo: false,
      fullPage: false,
      reports: [],
      notificacao: [],
      certificadoVencidoMsg: "",
      hoje: null,
      aniversariantes: [],
      dataToWhatsapp: null,
      wppOpenModal: false,
      produtoSelecionado: "produtos",
      fields: [
        {
          label: "Nome",
          field: "nome",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "WhatsApp",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
    };
  },
  async mounted() {
    this.getDataInit();
    this.getResumo();
  },
  computed: {
    ...mapGetters(["licenca"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),
    produtoSelecionadoLabel() {
      return this.produtoSelecionado === "produtos_estoque"
        ? "Produtos em Estoque"
        : "Produtos";
    },
    totalProdutosDashboard() {
      return Number(
        this.totais?.[this.produtoSelecionado] ?? this.totais?.produtos ?? 0
      );
    },
  },
  methods: {
    onCancel() {
      return true;
    },
    async getDataInit() {
      this.hoje = this.thisDateDashboard();
      this.aniversariantes = await this.getAniversariantes();
      this.isLoading = true;
      this.totais = await this.getTotaisDashboard();
      this.isLoading = false;
      const response = await this.$http.post("/empresa/validade-certificado", {
        id: this.currentUser.usuario_empresa.id_empresa,
      });
      this.certificadoVencidoMsg = response?.data.mensagem ?? "";
    },
    async getResumo() {
      try {
        this.isLoadingResumo = true;
        const { data } = await this.$http.get("/financeiro/saldo");
        this.resumo = data;
        this.isLoadingResumo = false;
      } catch (e) {
        console.log(e);
      }
    },
    async shareToWhatsapp(data) {
      this.dataToWhatsapp = data;
      this.wppOpenModal = true;
    },
  },
};
